import { authedFetch } from '@features/auth/api/authRefresh'
import type {
  RotateRecoveryKeyRequest,
  RotateRecoveryKeyResponse,
} from '@/crypto/key-hierarchy.types'

/**
 * Recovery Key rotation REST client (Track E-2)。
 *
 * `POST /api/users/me/recovery-key/rotate` — JwtAuthGuard 保護のため `authedFetch` 経由。
 * レスポンスは `{ ok: true }` のみ (新 mnemonic は client 側で既に生成済)。
 */
export const rotateRecoveryKey = (
  request: RotateRecoveryKeyRequest,
): Promise<RotateRecoveryKeyResponse> =>
  authedFetch<RotateRecoveryKeyResponse>('/users/me/recovery-key/rotate', {
    method: 'POST',
    body: request,
  })
